import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    width: 656,
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down(760)]: {
      width: '100%',
      padding: '0 16px',
    },
  },
  logo: {
    width: '100%',
    maxHeight: 80,
    objectFit: 'contain',
  },
  logoContainer: {
    maxWidth: 200,
    height: 'auto',
    marginBottom: 32,
  },
  card: {
    background: theme.palette.common.white,
    padding: 40,
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
    borderRadius: 8,
    width: '100%',
    [theme.breakpoints.down(760)]: {
      padding: '32px',
    },
  },
  lineThumbnail: {
    width: 200,
    height: 1,
    margin: '16px auto',
    background: theme.palette.secondary.light,
    [theme.breakpoints.down(760)]: {
      marginLeft: 'auto',
    },
  },
  line: {
    width: 200,
    height: 1,
    margin: '16px auto',
    background: theme.palette.secondary.light,
  },
  img: {
    marginTop: 40,
    width: 320,
    height: 200,
    borderRadius: 8,
  },
  informationThumbnail: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down(760)]: {
      flexDirection: 'column',
      marginLeft: 0,
    },
  },
  textThumbnail: {
    marginLeft: 28,
    [theme.breakpoints.down(760)]: {
      marginTop: 24,
      width: '100%',
      marginLeft: 'auto',
      textAlign: 'center',
    },
  },
  text: {
    marginLeft: 0,
    textAlign: 'center',
    marginTop: 40,
  },
  localisationThumbnail: {
    display: 'flex',
    [theme.breakpoints.down(760)]: {
      marginLeft: 0,
      justifyContent: 'center',
    },
  },
  localisation: {
    justifyContent: 'center',
    display: 'flex',
  },
  icon: {
    marginRight: 12,
    color: theme.palette.secondary.main,
  },
  information: {
    justifyContent: 'center',
  },
  priceThumbnail: {
    textAlign: 'center',
    [theme.breakpoints.down(760)]: {
      marginLeft: 0,
    },
  },
  price: {
    justifyContent: 'center',
  },
  address: {
    [theme.breakpoints.down(760)]: {
      textAlign: 'left',
    },
  },
}))
